import BlackboardReaderNode from './types/blackboard-reader';
import BlackboardWriterNode from './types/blackboard-writer';

export const blackboardNodes = {
  blackboardReader: BlackboardReaderNode,
  blackboardWriter: BlackboardWriterNode,
};
